import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import WebRoutes from './routes';


function App() {  
  return (
    <BrowserRouter basename={'/'} >
      <React.Suspense fallback={<span></span>}>
        <WebRoutes />
      </React.Suspense>
    </BrowserRouter>
  );
}

export default App;